import { jsx as o } from "react/jsx-runtime";
import "react";
import "axios";
import { isEmpty as i } from "./index22.js";
import { parseClassNames as a } from "./index21.js";
import "react-dom";
import "./index23.js";
import { Text as p } from "./index24.js";
import "./index25.js";
const h = ({
  id: s,
  error: r,
  className: t,
  type: e = "error"
}) => {
  if (i(r))
    return null;
  const m = a(["input-feedback-container", t]);
  return /* @__PURE__ */ o("div", { role: "alert", className: m, children: /* @__PURE__ */ o(p, { id: s, className: `input-${e}-message`, children: r }) });
};
export {
  h as FormFieldError
};
